import { useEffect, useSyncExternalStore } from 'react'

/**
 * Explorer PRÓPRIO de uma tela (SPEC-20261104-1413).
 *
 * Telas como Trabalho (Quadros) desenham o próprio painel lateral, fora do
 * explorer do shell. O botão do Explorer na barra do topo precisa mesmo assim
 * abrir e fechar esse painel (pedido do Cristian). A tela publica aqui o seu
 * estado e a ação de alternar; o AppShell lê e liga ao botão. Sem tela
 * registrada, o botão volta a comandar o explorer do shell.
 */
export type ExplorerProprio = { recolhido: boolean; alternar: () => void }

let atual: ExplorerProprio | null = null
const ouvintes = new Set<() => void>()

function publicar(valor: ExplorerProprio | null) {
  atual = valor
  for (const o of ouvintes) o()
}

function inscrever(o: () => void) {
  ouvintes.add(o)
  return () => {
    ouvintes.delete(o)
  }
}

/** Shell: o explorer próprio da tela atual, ou null. */
export function useExplorerProprio(): ExplorerProprio | null {
  return useSyncExternalStore(inscrever, () => atual, () => null)
}

/** Tela: registra o seu painel enquanto estiver montada. */
export function useRegistrarExplorerProprio(recolhido: boolean, alternar: () => void): void {
  useEffect(() => {
    publicar({ recolhido, alternar })
    return () => publicar(null)
  }, [recolhido, alternar])
}
